<template>
  <div class="print-page">
    <div class="print-toolbar no-print">
      <button class="btn block-btn me-2" @click="printPage">
        <i class="bi bi-printer me-2"></i>
        列印圖片
      </button>

      <button class="btn btn-outline-secondary" @click="$router.back()">
        返回
      </button>
    </div>

    <div
      v-if="imgUrl && !imageExpired"
      class="print-stage"
    >
      <img
        :src="resolvedImgUrl"
        :class="['print-image', imageAspectClass]"
        alt="Time portrait"
        @load="handleImageLoad"
        @error="handleImageError"
      >
    </div>

    <div v-else class="expired-box">
      <div class="expired-title">圖片已過期或不存在</div>
      <div class="expired-text">
        此列印連結可能已失效，請重新產生圖片。
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'TimePortraitPrint',
  data() {
    return {
      imageExpired: false,
      imageAspectClass: '',
    }
  },
  computed: {
    imgUrl() {
      return this.$route.query.img || ''
    },
    resolvedImgUrl() {
      const url = this.imgUrl
      if (!url) return ''

      if (url.startsWith('/media/')) {
        if (window.location.origin.includes(config.apiBaseUrl)) {
          return url
        }
        return `${config.apiBaseUrl}${url}`
      }

      return url
    },
  },
  methods: {
    printPage() {
      window.print()
    },
    handleImageError() {
      this.imageExpired = true
    },
    handleImageLoad(event) {
      const img = event.target
      const ratio = img.naturalWidth / img.naturalHeight

      if (Math.abs(ratio - 1) < 0.05) {
        this.imageAspectClass = 'is-square'
      } else if (ratio < 1) {
        this.imageAspectClass = 'is-portrait'
      } else {
        this.imageAspectClass = 'is-landscape'
      }
    },
  },
}
</script>

<style scoped>
.print-page {
  background: #fff;
}

.print-toolbar {
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.print-stage {
  text-align: center;
  padding: 16px;
}

.print-image {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  max-height: 80vh;
  width: auto;
  height: auto;
  object-fit: contain;
}

.expired-box {
  min-height: 60vh;
  display: flex;
  padding: 24px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #f8f9fa;
}

.expired-title {
  font-size: 24px;
  font-weight: 700;
  color: #495057;
}

.expired-text {
  margin-top: 12px;
  color: #6c757d;
}

@media print {
  .no-print {
    display: none !important;
  }

  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
    width: auto !important;
    height: auto !important;
    overflow: visible !important;
  }

  .print-page {
    display: block !important;
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
    width: auto !important;
    height: auto !important;
    min-height: 0 !important;
  }

  .print-stage {
    width: 100% !important;
    margin: 0 auto !important;
    padding: 2mm 0 !important;
    box-sizing: border-box !important;

    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    min-height: 134mm !important;
    text-align: center !important;
    overflow: visible !important;

    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  .print-image {
    display: block !important;
    margin: 0 auto !important;
    padding: 0 !important;
    border: 0 !important;

    width: auto !important;
    height: auto !important;
    max-height: 100% !important;
    object-fit: contain !important;

    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
  
}
</style>